const DEBUG = process.env.NODE_ENV === "development";
import axios from "axios";
import store from "./store";
import router from "./router";
import {decrypt} from './encrypt';

// const eventsHub = new Vue();


// This part runs only on full page load;
var userToken = localStorage.passport || sessionStorage.passport || null;
// console.log('userToken', userToken);
userToken = JSON.parse(userToken);

var instance = axios.create({
  baseURL: "https://play.qubit.ng/v1/engine/",
  // baseURL: "http://qubit.oleku.me:7080/v1/engine/",
  timeout: 300000,
  headers: {"Authorization": ("Bearer " + (userToken !== null ? decrypt(userToken.token, localStorage.keyAmus) : null)), "Content-Type": "application/json; charset=utf-8", "X-Qlid": localStorage.getItem("_$_RD$___E23ed"), "X-Channel": "web", "X-Profile": (localStorage.defaultProfileID || null)}
});

// End full page load part
router.beforeEach((to, from, next) => {
  userToken = localStorage.passport || sessionStorage.passport || null;
  if(to.path == "/auth/login" && userToken) {
    next("/dashboard");
  }
  else if(to.path !== "/auth/login" && to.path !== "/auth/register" && !userToken) {
    next("/auth/login");
  }
  else {
    next();
  }
});

instance.interceptors.request.use((config) => {
    // Ensure requests use the latest token that exists in the local storage
    var userToken = localStorage.passport || sessionStorage.passport || null;
    userToken = JSON.parse(userToken);
    config.headers["Authorization"] = "Bearer " + (userToken !== null ? decrypt(userToken.token, localStorage.keyAmus) : null);
    // if (DEBUG) { console.info("✉️ ", config.headers["Authorization"]); }
    return config;
}, (error) => {
    if (DEBUG) { console.error("✉️ ", error); }
    return Promise.reject(error);
});


instance.interceptors.response.use( (response) => {
    // Return a successful response back to the calling service
    return response;
  },(error) => {
    try{
    	if(error.response.status == 401){
        if(window.location.pathname !== "/auth/login"){
          localStorage.removeItem("last_url");
          localStorage.setItem("last_url", window.location.pathname);
        }

        $("#initiate").on("load", () => {
          $("#initiate").modal("hide");
        });
        store.commit("logout");
        window.location = "/auth/login";
      }
      else {
        return Promise.reject(error);
      }
    }
    catch(e) {
      return Promise.reject(error);
    }
  });

export default instance;
